<template>
	<!--sms-->
	<div class="edit" @click.self="close()">
		<div class="edit-con">
			<div class="edit-top">SMS sending<a @click="close" /></div>
			<div class="content">
				<div class="select-sms" @click="showAction = true">
					<img src="./img/select.png"/>
					<span>{{contName}}</span>
					<img src="./img/down.png"/>
				</div>
				<textarea v-model.trim="content" placeholder="enter template content" />
				<a class="send" @click="send">Send</a>
			</div>
		</div>
		<van-action-sheet v-model="showAction" :actions="smsTemplateList" @select="onSelect" />
	</div>
</template>

<script>
	import Vue from 'vue'
	import { ActionSheet } from 'vant';
	import 'vant/lib/cell/style';
	import 'vant/lib/action-sheet/style';
	Vue.use(ActionSheet);
	export default {
		data() {
			return {
				contName:"Please select",
				content:"",
				showAction:false,
				smsTemplateList:[]
			}
		},
		props:{
			close:{
				type:Function
			},
			smsPhone:{
				type:[Number,String],
				default:""
			},
			orderId:{
				type:[Number,String],
				default:""
			},
			pageType: String,
			sendList: Array
		},
		metaInfo: {
			title: 'Home'
		},
		created() {
			this.getSmsTemplate()
		},
		computed:{
			showSms:{
				get(){
					
				},
				set(){
					
				}
			}
		},
		methods: {
			send(){
				let self = this;
				if(this.contName === "Please select"){
					self.UTILS.logStr("Please select");
					return
				}
				if(!self.content){
					self.UTILS.logStr("Please complete the information");
					return;
				}
				if(self.pageType == 'dx'){
					self.UTILS.axiosRequest('post', self.PATHS.pwalletPath +'/sms/vrecord/add', {
						content: self.content,
						wpSmsVrecords: self.sendList
					}, (res)=>{
						self.UTILS.loadGif.hide();
						if(res.code == '0000'){
							self.$emit("updateSmsRecord",self.content);
							self.close();
							self.UTILS.logStr(res.message || "Send success");
						}else{
							self.UTILS.logStr(res.message);
						}
					});
				}else if(self.pageType == 'pl'){
					self.UTILS.axiosRequest('post', self.PATHS.pwalletPath +'/sms/arecord/addList', {
						content: self.content,
						wpSmsArecords: self.sendList
					}, (res)=>{
						self.UTILS.loadGif.hide();
						if(res.code == '0000'){
							self.$emit("updateSmsRecord",self.content);
							self.close();
							self.UTILS.logStr(res.message || "Send success");
						}else{
							self.UTILS.logStr(res.message);
						}
					});
				}else{
					let parmas = {
						orderId: this.orderId,
						phoneNumber:this.smsPhone,
						content:this.content
					}
					self.UTILS.axiosRequest('post', self.PATHS.pwalletPath +'/sms/arecord/add', parmas,(res) => {
						self.UTILS.loadGif.hide();
						if (res.code == '0000') {
							self.$emit("updateSmsRecord",self.content)
							self.close()
							self.UTILS.logStr(res.message || "Send success");
						} else {
							self.UTILS.logStr(res.message);
						}
					},1)
				}
			},
			
			getSmsTemplate(){
				let self = this;
				self.UTILS.axiosRequest('post', self.PATHS.pwalletPath +'/sms/atemp/list', {},(res) => {
					self.UTILS.loadGif.hide();
					if (res.code == '0000') {
						const list = res?.data || [];
						self.smsTemplateList = list.map(ele => {
							return{
								name:ele.smsName,
								smsAtempId:ele.smsAtempId,
								content:ele.context
							}
						})
					} else {
						self.UTILS.logStr(res.message);
					}
				},1)
			},
			onSelect(item) {
				this.contName = item.name;
				this.content = item.content;
				this.showAction = false;
			}
		}
	}
</script>

<style scoped>
	.edit{z-index:9;position: fixed;bottom: 0;left: 0;right: 0;width: 100%;height: 100%;background: rgba(0, 0, 0, 0.6);}
	.edit-con{ width: 6.74rem;background-color: #FFF; border-radius: 0.1rem; position: fixed; left: 50%; top: 70%; margin: -4.56rem 0 0 -3.37rem; overflow: hidden;}
	.edit-top{ height: 0.8rem; padding: 0 0.3rem; line-height: 0.8rem; text-align: left; font-size: 0.36rem; color: #FFF; background-color: #21D1CC;}
	.edit-top a{ width: 0.4rem; height: 0.4rem; background: url(./img/icon11.png) no-repeat center; background-size: cover; float: right; margin-top: 0.2rem;}
	.content{padding: 0.3rem;}
	.content .select-sms {padding: 0.2rem 0.3rem;display: flex;align-items: center;justify-content: space-between;border-radius: 0.1rem;border: 1px solid #000000;}
	.content .select-sms span{flex: 1;text-align: center;font-size: 0.30rem;color: #000000;}
	.content textarea{ width:100%; height: 3rem; padding: 0.1rem; line-height: 0.36rem; font-size: 0.28rem; color: #000; border: 0.02rem solid #787676; border-radius: 0.1rem; resize: none; margin: 0.24rem auto 0 auto;}
	.content .send{ width: 2rem; height: 0.8rem; line-height: 0.8rem; text-align: center; font-size: 0.36rem; color: #FFF; background-color: #21D1CC; border-radius: 0.1rem; display: block; margin: 0.7rem auto 0 auto;}	
</style>
